// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
//  vendor/src/context/AuthContext.js
//  ✅ Uses /vendors/send-otp + /vendors/verify-otp
//     (Vendor collection ONLY — not User collection)
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
import React, { createContext, useContext, useState } from 'react';
import API from '../api/config';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [vendor, setVendor] = useState(() => {
    try {
      const saved = localStorage.getItem('vd');
      return saved ? JSON.parse(saved) : null;
    } catch { return null; }
  });
  const [token, setToken] = useState(() => localStorage.getItem('vt') || null);

  // ✅ Step 1 — OTP bhejo (Vendor collection check)
  const sendOTP = async (email) => {
    // ✅ /vendors/send-otp — sirf Vendor collection mein dhundta hai
    const res = await API.post('/vendors/send-otp', { email });
    return res.data;
  };

  // ✅ Step 2 — OTP verify + token + vendor data
  const verifyOTP = async (email, otp) => {
    // ✅ /vendors/verify-otp — returns vendor JWT token directly
    const res = await API.post('/vendors/verify-otp', { email, otp });

    if (!res.data.success) {
      throw new Error(res.data.message || 'OTP verification failed');
    }

    const newToken   = res.data.token;
    const vendorData = res.data.vendor; // vendor object directly

    // Token save karo
    localStorage.setItem('vt', newToken);
    setToken(newToken);

    // Vendor data save karo (email ensure karo)
    const finalData = { ...vendorData, email };
    localStorage.setItem('vd', JSON.stringify(finalData));
    setVendor(finalData);

    return finalData;
  };

  const logout = () => {
    localStorage.removeItem('vt');
    localStorage.removeItem('vd');
    setToken(null);
    setVendor(null);
  };

  // Helper — email kahi se bhi mile
  const vendorEmail = vendor?.email || '';

  const isLoggedIn = !!token && !!vendor;

  return (
    <AuthContext.Provider value={{
      vendor,
      token,
      vendorEmail,
      sendOTP,
      verifyOTP,
      logout,
      isLoggedIn,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);